module.exports = __webpack_public_path__ + "static/media/san_bernardino_team.0e218bd1.jpg";